import "../assets/css/main.css";

import { createRouter, createWebHistory } from "vue-router";

import ContentPage from '../pages/ContentPage.vue'
import { store } from '../store/store'

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes: [
        {
            path: '/:pageName',
            name: 'root',
            component: ContentPage
        }
    ]
})

router.beforeResolve(async (to, from, next) => {


    console.log("before resolve")
    if (store.content === null) {
        try {
            let parsedRes = await fetch(
                `${process.env.VUE_APP_CMS_URL}/gmapi/content/sections?host=${process.env.VUE_APP_CMS_HOST}&route=/home`
            ).then((res) => res.json());
            let contObj = {};

            parsedRes.content[0].map((element) => {
                contObj[element.ID] = element.C.trim();
                const imgSrcMatch = element.C.match(/src="([^"]*)"/);
                if (imgSrcMatch !== null) {
                    contObj[element.ID] = imgSrcMatch[1];
                }
            });
            store.content = contObj;
        } catch (error) {
            console.error("Failed to get content ", error);
        }
    }

    if (store.siteMap === null) {

        store.imageUrl = `${process.env.VUE_APP_HTTPS === 'true' ? 'https' : 'http'}://${process.env.VUE_APP_CMS_URL}/medialibraries/Reg.betway.co.za/rbcz/`

        try {
            const sitemapObj = await fetch(
                `${process.env.VUE_APP_CMS_URL}/gmapi/Site/Get?host=${store.envHost}&userAgent=${navigator.userAgent
                }`
            ).then(async (res) => await res.json())

            sitemapObj.sitemap.map((item) => {
                if (item.P.endsWith('/')) {
                    item.P = item.P.slice(0, -1)
                }
                return item
            })

            store.siteMap = sitemapObj.sitemap.filter(f => f.C !== 'Home');
        } catch (error) {
            console.error('Failed to get content ', error)
        }
    }
    const page = store.siteMap.find(
        (element) => element.P === (to.path === '/' ? '/Sports' : to.path)
    )

    let pC = store.pageContents?.find((element) => element.PG === page.PG)

    if (pC === undefined) {
        try {
            const contObj = await fetch(
                `${process.env.VUE_APP_CMS_URL}/gmapi/Content/Get?host=${store.envHost}&pageGuid=${page.PG}`
            ).then(async (res) => await res.json())

            contObj.Page.PCM.WP.forEach((element) => {

                element.WPC = element.WPC.replaceAll('~', '')

                const imgSrcMatch = element.WPC.indexOf("imagepath");
                if (imgSrcMatch > -1) {
                    element.WPC = element.WPC.substring(imgSrcMatch + 11);

                    const imgSrcMatch2 = element.WPC.indexOf("</property>");
                    if (imgSrcMatch2 > -1) {
                        element.WPC = element.WPC.substring(0, imgSrcMatch2);
                    }
                }
            })

            store.pageContents.push({ PG: page.PG, Page: contObj.Page })
        } catch (error) {
            console.error('Failed to get content ', error)
        }
    }

    pC = store.pageContents?.find((element) => element.PG === page.PG)

    if (pC !== undefined) {
        store.pageContent = pC.Page;
        store.currentPage = page.C;
        store.currentPageColor = page.MID;
        store.navigationQuery = '?' + to.fullPath.split('?').findLast(() => 1 == 1);
    }
    
    if (to.path === '/') {
        next(page.C + to.fullPath.substring(1));
    } else {
        next();
    }

})

export default router